import React from 'react';

/**
 * Reusable hand-drawn doodle set for the Gathered Things brand.
 * Each doodle uses `currentColor`, so colour it with Tailwind text-* classes
 * (e.g. text-periwinkle, text-mustard, text-primary) and size/position with
 * width/height + absolute positioning on the parent. All are decorative.
 */

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const StarDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 48 48" className={className} {...base}>
    <path d="M24 3C25 14 27 21 45 24C27 27 25 34 24 45C23 34 21 27 3 24C21 21 23 14 24 3Z" />
  </svg>
);

export const SparkleDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 40 40" className={className} {...base}>
    <path d="M20 4L20 36M4 20L36 20M9 9L31 31M31 9L9 31" strokeWidth={1.8} />
  </svg>
);

export const SquiggleDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 90 20" className={className} {...base} preserveAspectRatio="none">
    <path d="M3 12C13 2 22 2 32 11C41 19 50 19 59 10C67 2 77 2 87 11" strokeWidth={3} />
  </svg>
);

export const HeartDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 44 40" className={className} {...base}>
    <path d="M22 37C10 28 3 21 3 13C3 7 7 3 12 3C16 3 20 6 22 10C24 6 28 3 32 3C37 3 41 7 41 13C41 21 34 28 22 37Z" strokeWidth={2.6} />
  </svg>
);

export const LeafDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 36 52" className={className} {...base}>
    <path d="M18 50L18 12" />
    <path d="M18 12C18 6 22 3 30 3C30 12 26 16 18 17" />
    <path d="M18 20C18 15 15 12 8 12C8 20 11 23 18 24" />
    <path d="M18 30C18 25 22 22 29 22C29 30 26 33 18 34" />
  </svg>
);

export const BlobDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 60 44" className={className} aria-hidden="true">
    <path
      d="M14 6C26 0 44 2 52 12C60 22 56 36 42 40C28 44 8 42 3 30C-1 20 4 11 14 6Z"
      fill="currentColor"
    />
  </svg>
);

export const LoopDoodle = ({ className = '' }) => (
  <svg viewBox="0 0 52 40" className={className} {...base}>
    <path d="M8 26C4 16 12 6 24 6C38 6 48 14 48 24C48 32 40 36 33 33C27 30 27 22 33 20C40 18 46 24 44 32" />
  </svg>
);
